/**
 * `/` is not a screen.
 *
 * `.agents/docs/design/information-architecture.md` names Scores as the app's
 * landing screen, so there is no home screen to render here: `/` exists only
 * to send a fan to `/scores`. Everything that points at `/` lands on the same
 * place because of this one redirect: the wordmark, the 404 screen's "Go to
 * home", the router error screen's "Go to home", and `safeRedirectPath`'s
 * fallback for a missing or unsafe `?redirect=`. The first three point here
 * only with a session; signed out they go to the marketing site instead
 * (`shell/HomeLink.tsx`, ISSUE-1101), because this route would only send the
 * visitor back to sign-in.
 *
 * One signed-out exception (ISSUE-1406): a visitor who opens the bare app
 * address, with nothing after the slash, and has not seen the intro tour in
 * this browser goes to `/welcome` first. Any search, hash or other path is
 * somebody's link and skips the tour (`features/welcome/introTourGate.ts`).
 *
 * The file itself stays because `infra/ci/checkRouteCoverage.ts` derives the
 * route path `/` from this file's name.
 */
import { createFileRoute, redirect } from "@tanstack/react-router";

import { requireSignedIn } from "../auth/requireSignedIn";
import {
  shouldShowIntroTour,
  WELCOME_PATH,
} from "../features/welcome/introTourGate";

export const Route = createFileRoute("/")({
  beforeLoad: (context) => {
    if (shouldShowIntroTour(context.location)) {
      // oxlint-disable-next-line typescript/only-throw-error
      throw redirect({ to: WELCOME_PATH, replace: true });
    }
    requireSignedIn(context);
    // oxlint-disable-next-line typescript/only-throw-error
    throw redirect({ to: "/scores", search: {}, replace: true });
  },
});
